import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React, { useState, useEffect } from 'react';
import { useIntl, IntlShape } from 'react-intl';
import styled from 'styled-components';

import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';
import { isRetailVenue } from 'common/utils';
import { languages } from 'config';
import { PageHeader } from 'modules/experience-core';
import { useExperienceModuleContext } from 'modules/experience-core';

import { VenueDetailsForm } from './VenueDetailsForm';

const currentLocale = (intl: IntlShape) => intl.locale as Language;

const Root = styled.div`
  flex: 1 1 auto;
  width: 100%;
  background-color: ${cbSemanticCssVars.surfaceMain};
`;

export const ExperienceBusinessDetails = () => {
  const intl = useIntl();
  const { selectedVenueExperienceEntity } = useExperienceModuleContext();
  const venue = selectedVenueExperienceEntity.experienceEntityObject as Venue;
  const [activeLang, changeLanguage] = useState<Language | null>(currentLocale(intl));
  const isRetail = isRetailVenue(venue);
  useEffect(() => {
    changeLanguage(currentLocale(intl));
  }, [intl]);

  return (
    <>
      <PageHeader />
      <Root>
        <VenueDetailsForm
          activeLang={activeLang}
          changeLanguage={changeLanguage}
          languages={languages}
          venue={venue}
          isRetail={isRetail}
        />
      </Root>
    </>
  );
};
